import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

import s from './styles.module.scss'

import { MapCardProps } from '../map-card.types'
import { useScreenSize } from '../../../../../../hooks/useScreenSize'
import { HouseStatus, TravelTypeEnum } from '../../../../../../lib/graphql'
import {
  breakpoints,
  useMediaQuery,
  useOnClickOutside,
} from '../../../../../../lib/hooks'
import { roundedPrice } from '../../../../../../utils'
import { Icon } from '../../../../../atoms'
import NextImage from '../../../../../atoms/containers/Image/next-image'
import {
  CurrencyAreaContextProvider,
  useTravelTypeContext,
} from '../../../../../contexts'
import { Capacity } from '../../../../../molecules'
import HouseSearchResultsCardPrices from '../../../../../molecules/house-search-results/house-search-results-card/house-search-results-card-prices/HouseSearchResultsCardPrices'
import { Rating } from '../../../../../molecules/rating/Rating'

export const MapHouseCard = ({
  element: { house },
  onClick,
  onClose,
  className,
}: MapCardProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const isMobile = useMediaQuery(breakpoints.newMobile)

  // New Collection consts
  const screenSize = useScreenSize()
  const PADDING_BETWEEN_MARKER_AND_HOUSE_CARD = 15
  const houseCardWidth = screenSize.width > 1600 ? 550 : 400
  const houseCardHeight = screenSize.width > 1600 ? 220 : 180
  const houseCardWidthWithPadding =
    houseCardWidth + PADDING_BETWEEN_MARKER_AND_HOUSE_CARD
  const houseCardHeightWithPadding =
    houseCardHeight + PADDING_BETWEEN_MARKER_AND_HOUSE_CARD

  // Collection consts
  /*const MARKER_SIZE = 30
  const OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD = 35*/

  const { travelType } = useTravelTypeContext()
  const [position, setPosition] = useState<any>({ top: 0, left: 0 })

  const calculateBetaPosition = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect()
      const mapContainer = document
        .getElementById('naboo_mapContainer')
        ?.getBoundingClientRect()

      const newPosition = { top: 0, left: 0 }

      if (mapContainer) {
        const pointerX = rect.left - mapContainer.left
        const pointerY = rect.top - mapContainer.top
        const gridWidth = mapContainer.width / 3
        const gridHeight = mapContainer.height / 3

        if (pointerY < gridHeight) {
          // Imaginez la carte comme une grille de 3x3
          // les cases sont numérotées de 1 à 9
          // la ligne du haut
          newPosition.top = PADDING_BETWEEN_MARKER_AND_HOUSE_CARD
          if (pointerX < gridWidth) {
            newPosition.left = PADDING_BETWEEN_MARKER_AND_HOUSE_CARD // 1
          } else if (pointerX < 2 * gridWidth) {
            newPosition.left = -houseCardWidthWithPadding / 2 // 2
          } else {
            newPosition.left = -houseCardWidthWithPadding // 3
          }
        } else if (pointerY < 2 * gridHeight) {
          // la ligne du milieu
          newPosition.top = PADDING_BETWEEN_MARKER_AND_HOUSE_CARD
          if (pointerX < gridWidth) {
            newPosition.left = PADDING_BETWEEN_MARKER_AND_HOUSE_CARD // 4
          } else if (pointerX < 2 * gridWidth) {
            newPosition.left = -houseCardWidthWithPadding / 2 // 5
          } else {
            newPosition.left = -houseCardWidthWithPadding // 6
          }
        } else {
          // la ligne du bas
          newPosition.top = -houseCardHeightWithPadding
          if (pointerX < gridWidth) {
            newPosition.left = PADDING_BETWEEN_MARKER_AND_HOUSE_CARD // 7
          } else if (pointerX < 2 * gridWidth) {
            newPosition.left = -houseCardWidthWithPadding / 2 // 8
          } else {
            newPosition.left = -houseCardWidthWithPadding // 9
          }
        }
      }

      setPosition(newPosition)
    }
  }

  /*const calculateNonBetaPosition = () => {
    if (ref) {
      const rect = ref.current?.getBoundingClientRect()
      ref.current?.scrollTop
      if (rect) {
        const newPosition = { top: 0, left: 0 }
        if (rect.left < 0) {
          newPosition.left = rect.left * -1
        } else if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
          newPosition.left = window.innerWidth - rect.right
        }

        if (
          rect.bottom + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD >
          (window.innerHeight || document.documentElement.clientHeight)
        ) {
          const mapContainerTop = document.getElementById('naboo_mapContainer')?.getBoundingClientRect().top
          if (
            mapContainerTop &&
            rect.top - mapContainerTop < rect.height + (MARKER_SIZE + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD) / 2
          ) {
            newPosition.top = mapContainerTop - rect.top + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD / 2
            if (
              window.innerWidth - rect.right >
              (rect.width + MARKER_SIZE + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD) / 2
            ) {
              newPosition.left = (rect.width + MARKER_SIZE + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD) / 2
            } else {
              newPosition.left = (rect.width + MARKER_SIZE + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD) / -2
            }
          } else {
            newPosition.top = (rect.height + (MARKER_SIZE + OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD) / 2) * -1
          }
        } else {
          newPosition.top = OLD_PADDING_BETWEEN_MARKER_AND_HOUSE_CARD
        }
        setPosition(newPosition)
      }
    }
  }*/

  useEffect(() => {
    calculateBetaPosition()
  }, [ref])

  useOnClickOutside(ref, () => onClose && onClose())

  const startingFees =
    typeof house.startingFees === 'number'
      ? house.startingFees
      : house.startingFees?.price

  return (
    <CurrencyAreaContextProvider context={{ currencyArea: house.currencyArea }}>
      <div
        className={clsx(s.isBeta, className, {
          [s.onClick]: !!onClick,
          [s.mobile]: isMobile,
        })}
        onClick={() => onClick && onClick()}
        style={{
          top: position.top,
          left: position.left,
        }}
        ref={ref}
      >
        {onClose && (
          <div
            className={s.close}
            onClick={(e) => {
              e.stopPropagation()
              onClose()
            }}
          >
            <Icon name='cross' size={15} />
          </div>
        )}
        {startingFees && house.status === HouseStatus.PUBLISHED ? (
          <div className={s.cardTag}>
            <div className={s.startingFees}>
              <span>À partir de </span>
              <span className={s.price}>{roundedPrice(startingFees)} HT</span>
              <span>
                {' '}
                / voyageur{' '}
                {travelType === TravelTypeEnum.NIGHTLY_TRIP && <>/nuit</>}
              </span>
            </div>
          </div>
        ) : null}

        <div className={s.imageContainer}>
          <NextImage src={house.coverPicture.uri || ''} alt={house.title} />
        </div>
        <div className={clsx(s.informations)}>
          <div>
            {house.address && (
              <div className={s.address}>
                {house.address.city}, {house.address.department}{' '}
              </div>
            )}
            <div className={s.title}>{house.title}</div>
            <Rating
              rating={house?.googleRating?.rating}
              userRatingsTotal={house?.googleRating?.userRatingsTotal}
            />
            <Capacity
              className={s.mapCapacity}
              beds={house.numberOfBeds ?? 0}
              bedrooms={house.numberOfBedrooms ?? 0}
              capacity={house.capacity}
              dailyMaxCapacity={house.options?.studyDay.options?.capacity.max}
              corporateEveningEventMaxCapacity={
                house.options?.corporateEvening.options?.capacity.max
              }
              numberOfWorkspaces={house.numberOfWorkspaces}
            />
          </div>

          <HouseSearchResultsCardPrices
            house={house}
            numberOfNights={1}
            numberOfDays={1}
            travelType={travelType}
          />
        </div>
      </div>
    </CurrencyAreaContextProvider>
  )
}
